import SHARED_META from './shared'

export default {
  en_IE: {
    title: 'The Superdrug Online Doctor',
    meta: [
      ...SHARED_META,
      {
        name: 'description',
        content: '' // Empty description in live, adding just in case it's for some SEO reason
      },
      {
        name: 'language',
        content: 'en-ie'
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/ms-icon-144x144.png'
      }
    ],
    link: [
      {
        rel: 'apple-touch-icon',
        sizes: '57x57',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-57x57.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '60x60',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-60x60.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '72x72',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-72x72.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-76x76.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '114x114',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-114x114.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-120x120.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '144x144',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-144x144.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-152x152.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/apple-icon-180x180.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/android-icon-192x192.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/favicon-32x32.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/favicon-96x96.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '48x48',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/favicon-48x48.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'https://onlinedoctor.superdrug.com/ie/assets/dist/images/favicons/sd/favicon-16x16.png'
      }
    ]
  }
}
